// import React, { useState } from "react";
// import { GoogleOAuthProvider, GoogleLogin } from "@react-oauth/google";
// import axios from "axios";
// import { useNavigate } from "react-router-dom";
// import { message } from "antd";
// import { FcGoogle } from "react-icons/fc";
// import { baseUrl } from "../utills";

// const GoogleLoginButton = () => {
//   const [loading, setLoading] = useState(false);
//   const [messageApi, contextHolder] = message.useMessage();
//   const navigate = useNavigate();


//   const handleGoogleSuccess = async (credentialResponse) => {
//     console.log("credentialResponse:", credentialResponse);

//     setLoading(true);
//     try {
//       const res = await axios.get(baseUrl + "login_with_google", {
//         token: credentialResponse.credential,
//       });

//       if (res?.status === 200) {
//         setLoading(false);
//         messageApi.open({
//           type: "success",
//           content: "Logged in successfully!",
//         });
//         navigate("/layout");
//       }
//     } catch (error) {
//       setLoading(false);
//       messageApi.open({
//         type: "error",
//         content: error?.response?.data?.detail || "Failed to login with Google",
//       });
//       console.error("Login error", error);
//     }
//   };

//   const handleGoogleFailure = () => {
//     messageApi.open({
//       type: "error",
//       content: "Google login failed. Please try again.",
//     });
//   };

//   return (
//     <GoogleOAuthProvider clientId="962519029970-32adcadmglo3o4rrs468s849ttuj7ulj.apps.googleusercontent.com">
//       {contextHolder}
//       <GoogleLogin
//         onSuccess={handleGoogleSuccess}
//         onError={handleGoogleFailure}
//         useOneTap
//       />
     
//     </GoogleOAuthProvider>
//   );
// };

// export default GoogleLoginButton;

import React from "react";
import { useNavigate } from "react-router-dom";
import { GoogleOAuthProvider, GoogleLogin } from "@react-oauth/google";
import { jwtDecode } from "jwt-decode";
 // To decode Google JWT token

const clientId = "962519029970-32adcadmglo3o4rrs468s849ttuj7ulj.apps.googleusercontent.com"; // Replace with your actual Client ID

const GoogleLoginButton = () => {
  const navigate=useNavigate();
  const handleSuccess = (response) => {
    const decoded = jwtDecode(response.credential);
    console.log("User Info:", decoded);

    // Store user data in localStorage or state
    localStorage.setItem("user", JSON.stringify(decoded));

    navigate("/layout");
  };

  const handleFailure = () => {
    console.log("Google Sign-In Failed");
  };

  return (
    <GoogleOAuthProvider clientId={clientId}>
      <div>
        <GoogleLogin onSuccess={handleSuccess} onError={handleFailure} />
      </div>
    </GoogleOAuthProvider>
  );
};

export default GoogleLoginButton;
